// removed by extract-text-webpack-plugin
module.exports = {"download-chrome-container":"download-chrome-container","logo-img":"logo-img","warning-message":"warning-message","chrome-logo":"chrome-logo","download-btn":"download-btn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/downloadChrome/downloadChrome.scss
// module id = 939
// module chunks = 0